
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

 
const ViewStackingData = (props) => {
    
    const truckData = (e) => {
        e.stopPropagation();
        props.context.componentParent.onClickShowStackingData(props);
    };
  
    return (
        <div>
            <button className="label label-warning" onClick={truckData} style={{color:"#000",border:"0px"}}>
                <i className="fa fa-sitemap"></i>Stacking
            </button>
            
        </div>
    );
};

export default ViewStackingData;
